import React, { Component } from "react";
import { connect } from "react-redux";
import "../movies/details.css";
import * as detailActions from "../../redux/actions/detailsActions";
import { bindActionCreators } from "redux";
import { Badge, Row } from "reactstrap";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import * as movieActions from "../../redux/actions/movieActions";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Fade from "react-reveal/Fade";

class MovieDetail extends Component {
  state = { count: 2, genres: [], obj: false };

  checkMovie() {
    const addBtn = document.querySelector(".addToLS");
    const href = window.location.pathname.replace("/movie/", "");

    if (JSON.parse(localStorage.getItem("addedMovies"))) {
      let count = 0;
      for (
        let b = 0;
        b < JSON.parse(localStorage.getItem("addedMovies")).length;
        b++
      ) {
        if (
          parseInt(href) ===
          JSON.parse(localStorage.getItem("addedMovies"))[b].id
        ) {
          count++;
        }
      }
      if (count === 1) {
        addBtn.textContent = "Added ✔";
      }
    }
  }

  checkCount() {
    var timeleft = 2;
    var load = document.querySelector(".lds-ring");
    var all = document.querySelector(".all_page2");
    var downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        this.checkMovie();
        clearInterval(downloadTimer);
        load.style.display = "none";
        all.style.opacity = "1";
      } else {
        timeleft -= 1;
        this.setState({ count: this.state.count - 1 });
      }
      /*{this.props.choosenMovie.genres.map((movie) =>(
                    <p className="d-inline mx-1">
                      {movie.name}
                    </p>
                  ))}
                  */
    }, 1000);
  }
  toStringMovie() {
    const oldItems = JSON.parse(localStorage.getItem("addedMovies")) || [];
    var newMovie;
    const addBtn = document.querySelector(".addToLS");

    /* Checking item to duplicate */
    if (JSON.parse(localStorage.getItem("addedMovies"))) {
      let count = 0;
      let index;

      for (
        let b = 0;
        b < JSON.parse(localStorage.getItem("addedMovies")).length;
        b++
      ) {
        if (
          this.props.choosenMovie.id ===
          JSON.parse(localStorage.getItem("addedMovies"))[b].id
        ) {
          count++;
          index = b;
        }
      }

      /* Adding item to LS*/
      if (count === 0) {
        addBtn.textContent = "Added ✔";

        alertify.set("notifier", "position", "top-center");
        alertify.success("Added to list").delay(1);

        newMovie = this.props.choosenMovie;
        oldItems.push(newMovie);
        localStorage.setItem("addedMovies", JSON.stringify(oldItems));
      } else {
        /* Delete item from LS*/
        addBtn.textContent = "Watch Later";

        alertify.set("notifier", "position", "top-center");
        alertify.error("Removed from list").delay(1);

        if (JSON.parse(localStorage.getItem("addedMovies"))) {
          if (JSON.parse(localStorage.getItem("addedMovies")).length === 1) {
            localStorage.removeItem("addedMovies");
          } else {
            const oldItems =
              JSON.parse(localStorage.getItem("addedMovies")) || [];
            oldItems.splice(index, 1);

            localStorage.setItem("addedMovies", JSON.stringify(oldItems));
          }
        }
      }
    } else {
      /* For first movie to LS */
      addBtn.textContent = "Added ✔";

      alertify.set("notifier", "position", "top-center");
      alertify.success("Added to list").delay(1);

      newMovie = this.props.choosenMovie;

      oldItems.push(newMovie);
      localStorage.setItem("addedMovies", JSON.stringify(oldItems));
    }
  }
 
  componentDidMount() {
    const href = window.location.pathname.replace("/movie/", "");
    href.replace("/movie", "a");
    if (parseInt(href) > 50) {
      this.props.actions.getChoosenMovie(parseInt(href));
      this.props.actions.getSimilarMovies(parseInt(href));
    } else {
      this.props.actions.getChoosenMovie(localStorage.getItem("id"));
      this.props.actions.getSimilarMovies(localStorage.getItem("id"));
    }

    this.checkCount();
  }
  render() {
    localStorage.setItem(
      "genres",
      JSON.stringify(this.props.choosenMovie.genres)
    );
    const img = this.props.choosenMovie.backdrop_path;

    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 2,
      autoplay: true,
    };
    return (
      <div className="all bg-danger">
        <div className="">
          <div className="img2 text-center">
            <div className="lds-ring ring2">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div className="all_page2">
          <Fade top className="movie-row">
            <img
              className="movie-img"
              src={`https://image.tmdb.org/t/p/original/${img}`}
              alt="ass"
            ></img>

            <div className="movie-details w-100" style={{width:"100%"}}>
              <h2 className="title-detail  ml-3">
                {this.props.choosenMovie.title}
                <Badge color="#FFC107" className="ml-3 mb-1 vote badge">
                  {this.props.choosenMovie.vote_average}
                </Badge>
              </h2>
              <div className="d-block  ml-3">
                <a
                  href={this.props.choosenMovie.homepage}
                  className=" btn button btn-play"
                >
                  <img src="/images/play-icon-black.png" alt="sa"></img>
                  <span>Play</span>
                </a>
                <a
                  href={`https://www.imdb.com/title/${this.props.choosenMovie.imdb_id}/?pf_rd_m=A2FGELUUNOQJNL&pf_rd_p=e31d89dd-322d-4646-8962-327b42fe94b1&pf_rd_r=NHCESRZZR2V7R47PG043&pf_rd_s=center-1&pf_rd_t=15506&pf_rd_i=top&ref_=chttp_tt_11`}
                  className="btn button btn-trailer"
                >
                  <img src="/images/play-icon-white.png" alt="saa"></img>
                  <span>Trailer</span>
                </a>
              </div>

              <div className="overview  ml-3">
                {this.props.choosenMovie.overview}
              </div>

              <div>
                <div className="mt-2  ml-1">
                  <div>
                    <p className="info d-inline ml-3">
                      {this.props.choosenMovie.release_date}
                    </p>
                    {this.state.count < 1 &&
                      JSON.parse(localStorage.getItem("genres")).map(
                        (movie) => (
                          <p key={movie.id} className="d-inline mx-1 info">
                            {movie.name}
                          </p>
                        )
                      )}
                  </div>
                </div>
              </div>

              <button
                onClick={() => this.toStringMovie()}
                className="btn button btn-trailer btn2 ml-3"
                style={{ marginLeft: "-100px !important" }}
              >
                <span className="addToLS ">Watch Later</span>
              </button>
              <Link to="/watch-later">
                <button className="btn button btn-trailer addeds btn2">
                  <img
                    className="imd_go"
                    src="/images/added.png"
                    alt="go"
                  ></img>
                  <span>Added Movies</span>
                </button>
              </Link>
                <div style={{overflow:"hidden"}}>
                {this.props.similarMovies.length > 0 && (
                <Row xl="12">
                  <h2 className="title-detail mt-5">
                    Some Similar Movies
                  </h2>
                  {this.props.similarMovies && (
                    <Carousel {...settings}>
                      {this.props.similarMovies.map((movie) => (
                        <Wrap key={movie.id}>
                          <div style={{ margin: "6px" }}>
                            <a
                              onClick={() => this.movieDetail(movie.id)}
                              href={`/movie/${movie.id}`}
                              
                            >
                              <img
                                className="slider-img"
                                alt={movie.title}
                                src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                                key={movie.poster_path}
                              ></img>
                            </a>
                          </div>
                        </Wrap>
                      ))}
                    </Carousel>
                  )}
                </Row>
              )}            
              </div>
             
              
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

const Carousel = styled(Slider)`
  width: 100%;
  margin: 0px;
  margin-top: 50px;
  overflow:hidden;
  & > button {
    opacity: 1;
    height: 100%;
    width: 5vw;
    z-index: 1;
    &:hover {
      opacity: 1;
      transition: opacity 0.3s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 13px;
      color: rgb(150, 158, 251);
    }
  }
  li.slick-active button:before {
    color: rgb(150, 158, 251);
    font-size: 16px;
  }
  .slick-next:before {
    font-size: 50px;
    @media only screen and (max-width: 768px) {
      font-size: 35px;
    }
  }

  .slick-prev:before {
    font-size: 50px;
    @media only screen and (max-width: 768px) {
      font-size: 35px;
    }
  }
  .slick-list {
    overflow: initial;
    width: 650px;
    border-radius: 1rem;
    @media only screen and (max-width: 768px) {
      width: 390px;
    }
  }

  .slick-prev {
    left: 30px;
    @media only screen and (max-width: 768px) {
      top: 100px;
      left: 30px;
    }
  }
  .slick-next {
    right: 30px;
    @media only screen and (max-width: 768px) {
      top: 100px;
      right: 40px;
    }
  }
`;

const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  div {
    border-radius: 4px;
    border-radius: 1rem;

    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;
    img {
      width: 200px;
      height: 330px;
      border-radius: 1rem;
      @media only screen and (max-width: 768px) {
        width: 111px;
        height: 200px;
      }
    }
    &:hover {
      padding: 0;
      border: 4px solid rgba(249, 249, 249, 0.8);
      transition-duration: 300ms;
    }
  }
`;

function mapStateToProps(state) {
  return {
    choosenMovie: state.detailReducer,
    similarMovies: state.similarMoviesReducer,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getChoosenMovie: bindActionCreators(detailActions.getMovie, dispatch),
      getSimilarMovies: bindActionCreators(
        movieActions.getSimilarMovies,
        dispatch
      ),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MovieDetail);
